import { Box, Typography, useTheme } from "@mui/material"
import { useEffect, useState } from "react"

const TextEstadogTicketID = ({titulo, descripcion, abiertoCerrado, estado}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [info, setInfo] = useState({
        color: '#74767f',
        background: '#e7e7e9',
        texto: 'En Proceso'
    })

    useEffect(() => {
        if(abiertoCerrado){
            if(!estado){
                setInfo({
                    color: '#018155',
                    background: '#E6F8F2',
                    texto: 'Abierto'
                })
            }else{
                setInfo({
                    color: '#74767f',
                    background: '#e7e7e9',
                    texto: 'Cerrado'
                })
            }
        }else{
            switch (descripcion) {
                case 'NO VENCIDO':
                    setInfo({
                        color: '#74767f',
                        background: '#e7e7e9',
                        texto: 'NO VENCIDO'
                    })
                    break;
                case 'VENCIDO':
                    setInfo({
                        color: '#9d0b0b',
                        background: '#fce7e7',
                        texto: 'VENCIDO'
                    })
                    break;
                default:
                    setInfo({
                        color: '#74767f',
                        background: '#e7e7e9',
                        texto: 'NO VENCIDO'
                    })
                    break;
            }
        }
    }, [descripcion, abiertoCerrado, estado])

    return (
        <Box 
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: 1,
                gap: 2
            }}
        >
            <Typography sx={{
                color: isDarkMode ? '#b0bec5' : '#2c3e50',
                fontWeight: 600,
                fontSize: 12,
                minWidth: 'fit-content',
                flexShrink: 0
            }}>
                {titulo}:
            </Typography>
            
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    px: 0,
                    py: 0,
                    borderRadius: '20px',
                    background: info?.background,
                    minWidth: '100px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
                }}
            >
                <Typography
                    sx={{
                        fontWeight: 700,
                        fontSize: 12,
                        color: info?.color,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.5
                    }}
                    component='div'
                >
                    <Box component="span" sx={{fontSize: 16}}>•</Box>
                    {info?.texto}
                </Typography>
            </Box>
        </Box>
    )
}

export default TextEstadogTicketID